<template>
  <div class="modal-container" tabindex="0" @click="handleClick" @keyup.esc="$emit('triggerCloseModal')">
    <div class="reset-plan-modal" ref="modal">
      <h2 class="modal-title">
        Para cambiar de temporada el plan debe estar vacío
      </h2>
      <div class="d-flex justify-content-center align-items-center gap-2 reset-plan-modal-body">
        ¿Desea limpiar el plan?
      </div>
      <div class="action-btn-container">
        <button class="action-btn cancel-btn" @click="$emit('triggerCloseModal')">Cancelar</button>
        <button class="action-btn confirm-btn" @click="handleSubmit">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import planStore from '../store/plan';

export default {
  name: 'reset-plan-modal',
  data() {
    return {
    }
  },
  methods: {
    ...mapActions(planStore, ['updateCurrentPlanData']),
    handleClick(e) {
      if (!this.$refs.modal?.contains(e.target) && e.target.classList[0] !== 'action-btn') {
        this.$emit('triggerCloseModal')
      }
    },
    async handleSubmit() {
      await this.updateCurrentPlanData(null, 'changeSeasonWithProductSelected')
      this.$emit('triggerCloseModal')
    }
  }
}
</script>

<style scoped>
.action-btn-container {
  display: flex;
  gap: 1.5rem;
}

.error {
  width: 80%;
  display: flex;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--white);
  font-weight: 700;
  background-color: red;
  padding: 1rem;
}

.action-btn {
  width: 20rem;
  height: 3.3rem;
  font-size: 2.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--main-border-radius);
}

.confirm-btn {
  font-size: 1.5rem;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid #d6a02d;
  transition: all 0.3s;
}

.cancel-btn {
  font-size: 1.5rem;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid #d6a02d;
  transition: all 0.3s;
}

.confirm-btn:hover {
  background-color: #cec600;
  background-color: transparent;
  color: #14bf98;
  color: #d6a02d;
  text-decoration: none;
  border: 0.125rem solid #d6a02d;
}

.cancel-btn:hover {
  background-color: #cec600;
  background-color: transparent;
  color: #14bf98;
  color: #d6a02d;
  text-decoration: none;
  border: 0.125rem solid #d6a02d;
}


.modal-title {
  display: flex;
  justify-content: center;
  font-size: 2.7rem;
  font-size: 2.2rem;
  font-size: 1.7rem;
}

.reset-plan-modal-body {
  font-size: 1.5rem;
  height: 2rem;
}

.reset-plan-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 55rem;
  width: 85%;
  height: 23rem;
  background-color: white;
  z-index: 1;
  border-radius: var(--main-border-radius);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  z-index: 2;
}


.modal-container {
  width: 100%;
  height: 100%;
  background-color: #d9d9d9db;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
}


@media screen and (max-width: 700px) {


  .action-btn-container {
    width: 80%;
    gap: 1.5rem;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .modal-title {
    font-size: 1.2rem;
    width: 70%;
    font-weight: 400;
  }

  .confirm-btn,
  .cancel-btn {
    width: 80%;
    /* display: inline-block; */
    /* padding: 1.375rem 2.125rem 1.375rem 2.125rem; */
    width: 50%;
    border-radius: 0.75rem;
    font: 500 1rem / 0 Roboto, sans-serif;
  }

  .reset-plan-modal-body {
    font-size: 1.4rem;
  }




}
</style>